function PageBookListController(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	var SEARCH_QUERY_MIN_LENGTH = 3;
	var RESULT_DATA_MIN_LENGTH = 16; // minimum length of result data to be considered correct result

	
	/* PRIVATE VARIABLES */
	var submitEnabled = true;
	var form;
	var searchInput;
	var bookTypeInput;
	var listContainer;
	var noResultsMessage;
	var savedContent;
	var searchScope;
	var searchSymlinks = 0;


	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}	
	
	
	function onSearchComplete(data){
		// loading indicator
		listContainer.removeClass('loadingContainer');
		
		if(data.length > RESULT_DATA_MIN_LENGTH) {
			noResultsMessage.hide();
			listContainer.html(data);
			// update DOM content
			onAjaxContentLoad();			
		} else {
			noResultsMessage.show();
		}
		submitEnabled = true;
	}
	
	
	function search() {
		if(searchScope && submitEnabled) {
			var query = searchInput.val();
			var bookType = bookTypeInput.val();
			
			if (query.length > 0 && query.length < SEARCH_QUERY_MIN_LENGTH) {	
				// query is too short
				showAlert('Zadejte alespoň ' + SEARCH_QUERY_MIN_LENGTH + ' znaky.');
			} else {
				// query is empty or correct length
				submitEnabled = false;
				listContainer.empty();
				// loading indicator
				listContainer.addClass('loadingContainer');
				
				$.post({
					url: appConfig.api.searchBook,
					data: {
						query: query,
						bookType: bookType,
						scope: searchScope,
						symlinks: searchSymlinks
					},
					success: onSearchComplete,
					dataType: 'html'
				});				
			}
		}
	}

	
	/**
	 * Save the original content of container for later restoration
	 */
	function saveOriginalContent(){
		savedContent = listContainer.clone().html();
	}
	
	
	/**
	 * Restore the original content
	 */
	function restoreOriginalContent(){
		noResultsMessage.hide();
		if(savedContent) {
			listContainer.html(savedContent);
			// update DOM content
			onAjaxContentLoad();			
		}
	}
	

	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			// object references
			form = $('#bookSearchForm', _this.container);
			searchScope = parseInt(form.data('searchScope'));
			searchSymlinks = parseInt(form.data('searchSymlinks'));
			searchInput = $('input[name="query"]', form);
			bookTypeInput = $('select[name="bookType"]', form);
			listContainer = $('#listContainer', _this.container);
			noResultsMessage = $('.noResultsMessage', _this.container);
			
			// handlers
			form.submit(function(e) {
				e.preventDefault();
				search();
			});
			bookTypeInput.change(function(e) {
				e.preventDefault();
				search();
			});
			
			saveOriginalContent();
			
			_this.inited = true;
		}
	};
	

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
